var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuerioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 71.5V19.5H66.5V55.5L85 71.5Z",
    fill: "#522785",
    stroke: "#522785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.5V1H68L84.5 18.5H19.5Z",
    fill: "#29ABE2",
    stroke: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 66.5H1L1 18L18.5 1.5L18.5 66.5Z",
    fill: "#F15A24",
    stroke: "#F15A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 83.5L1.5 67H57.5L73.5 83.5H17.5Z",
    fill: "#FBB03B",
    stroke: "#FBB03B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 42.5,
    width: 5,
    height: 5,
    fill: "#FBB03B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 57.5,
    width: 4,
    height: 4,
    fill: "#FBB03B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 72.5,
    width: 4,
    height: 4,
    fill: "#522785"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 54.5,
    width: 3,
    height: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 72.5,
    width: 3,
    height: 3,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 58,
    width: 5,
    height: 5,
    fill: "#FBB03B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 48.5,
    width: 5,
    height: 5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 75.5,
    width: 5,
    height: 5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 70.5,
    width: 5,
    height: 5,
    fill: "#522785"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 86.5,
    width: 5,
    height: 5,
    fill: "#522785"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 40.5,
    width: 6,
    height: 6,
    fill: "#FBB03B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 85.5,
    width: 6,
    height: 6,
    fill: "#522785"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 50.5,
    width: 7,
    height: 7,
    fill: "#FBB03B"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 75.5,
    width: 7,
    height: 7,
    fill: "#522785"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 65.5,
    width: 7,
    height: 7,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 64.5,
    width: 7,
    height: 7,
    fill: "#FBB03B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 63.5,
    width: 7,
    height: 7,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 64.5,
    width: 7,
    height: 7,
    fill: "#522785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuerioLogo);
export default __webpack_public_path__ + "static/media/QuerioLogo.d3a4857b31e31bfb2eca185049ffab52.svg";
export { ForwardRef as ReactComponent };